export default __webpack_public_path__ + "static/media/google.bc7d2f65.svg";